import { createFeatureSelector, createSelector } from '@ngrx/store'
import { State } from './config.reducer'

export const getConfigStore = createFeatureSelector<State>('config')

export const getListenConfig = createSelector(getConfigStore, state => state.listenConfig)
export const getStaticConfig = createSelector(getConfigStore, state => state.staticConfig)
export const getFeatures = createSelector(getConfigStore, state => state.staticConfig?.features)
